import { BOUNDING_BOX_MARGIN } from '../../constants';
import { getCoordinateArray } from '../utilities/utilities';
import { Point, Polygon } from 'ol/geom';
import Feature from 'ol/Feature';
import { fromExtent as OlPolygonFromExtent } from 'ol/geom/Polygon';

export function getMobileBoundingBox(user) {
    if (user.organizationBBox[0] &&
        user.organizationBBox[1] &&
        user.organizationBBox[2] &&
        user.organizationBBox[3]) {
        // bounding-box is defined
        return user.organizationBBox;
    } else {
        // Get bounding-box from the organisation polygon
        return calculateOrganisationBBox(user.organizationCoordinates, true);
    }
}

/**
 * Get organization extents (minX, minY), (maxX, maxY) with a certain percentage of width and height added to the extend
 * @return {array} array with extents with margin added or null
 */
export function getBoundingBoxWithMargin(user) {
    const orgExtent = getMobileBoundingBox(user);
    if (!orgExtent) {
        return null;
    }

    const marginWidth = (orgExtent[2] - orgExtent[0]) / BOUNDING_BOX_MARGIN;
    const marginHeight = (orgExtent[3] - orgExtent[1]) / BOUNDING_BOX_MARGIN;

    return [orgExtent[0] - marginWidth, orgExtent[1] - marginHeight, orgExtent[2] + marginWidth, orgExtent[3] + marginHeight];
}

/**
 * Calculate the bounding box for the given polygon (strict = true) or coordinate-list (strict = false)
 * @param {string} coordinates space delimited string with coordinates
 * @param {bool} strict flag for checking the number of ordinates
 * @return {array} boundingbox array: [minX (left), minY (bottom), maxX (right), maxY (top)]
 */
export function calculateOrganisationBBox(coordinates, strict) {
    if (coordinates) {
        // Maak array van ordinaten uit $scope.org.coordinates, splits op een spatie
        const ordinates = coordinates.split(' ');
        // Minimum of 3 points as closed polygon. (= 4 points to close the polygon, starting point equals ending point)
        //                                        (= 8 ordinates, 2 per point, x & y)
        if (!strict || ordinates.length > 7) {
            return calculatePolygonBBox(coordinates);
        }
    }
    return null;
}

/**
* Bereken de omhullende rechthoek uit de opgegeven polygoon.
* LO: minX, minY
* RB: maxX, maxY
* @param {string} coordinates door spaties gescheiden coordinatenlijst
* @return {array} array met bbox ordinaten (L, O, R, B)
*/
export const calculatePolygonBBox = function (coordinates) {
    // initialiseer bounding box
    let minX = 1000000;
    let minY = 1000000;
    let maxX = -1000000;
    let maxY = -1000000;
    // hulp variabelen
    let ordNumber = 0;
    let ordX = 0;
    let ordY = 0;
    // oude coordinaat paren worden gescheiden door een comma
    coordinates = coordinates.split(',').join(' ');
    // maak array van ordinaten uit coordinates, splits op een spatie
    const ordinates = coordinates.split(' ');
    // doorloop alle ordinaten
    for (const ordinate of ordinates) {
        if (ordinate.trim().length > 0) {
            // hoog het ordinaat nummer op
            ordNumber = ordNumber + 1;
            if (ordNumber % 2 === 1) {
                ordX = parseInt(ordinate);
            } else if (ordNumber % 2 === 0) {
                ordY = parseInt(ordinate);
                // Check minX
                if (ordX < minX) {
                    minX = ordX;
                }
                // Check minY
                if (ordY < minY) {
                    minY = ordY;
                }
                // Check maxX
                if (ordX > maxX) {
                    maxX = ordX;
                }
                // Check maxY
                if (ordY > maxY) {
                    maxY = ordY;
                }
            }
        }
    }
    // array met LO en RB
    return [minX, minY, maxX, maxY];
};

/**
 * Returns true if given point is inside the organization bbox, false otherwise
 * @param {Object} user current user
 * @param {olPoint} pointGeometry geometry of point
 */
export function isPointInsideOrgPolygonOrBBox(user, pointGeometry) {
    if (pointGeometry instanceof Point === false) {
        return false;
    }

    let polygon = null;
    if (user.organizationCoordinates && user.organizationCoordinates !== '') {
        const organizationCoordinates = user.organizationCoordinates.split(' ');
        polygon = new Polygon([getCoordinateArray(organizationCoordinates)]);
    } else {
        polygon = OlPolygonFromExtent(user.organizationBBox);
    }

    var feature = new Feature({ geometry: polygon });

    // returns true if polygon geometry includes the specified coordinate
    // if the coordinate is on the boundary of the polygon geometry, returns false
    return feature.getGeometry().intersectsCoordinate(pointGeometry.getCoordinates());
}
